import { memo } from 'react';

import { type SortDirection } from '@air/api/types';

import { SortMenu } from '~/components/SortButtons/SortMenu';
import { SORT_BUTTON } from '~/constants/testIDs';

export type ViewSortingMenuComponentProps = {
  availableSortOptions: readonly string[];
  currentlySortedBy: string;
  sortDirection: SortDirection;
  dataTestId?: string;
  onChange: (sortingFieldName: string, direction: SortDirection) => void;
  showDirectionInMenu?: boolean;
};

export const ViewSortingMenuComponent = memo(
  ({
    currentlySortedBy,
    onChange,
    sortDirection,
    availableSortOptions,
    showDirectionInMenu,
  }: ViewSortingMenuComponentProps) => {
    return (
      <SortMenu
        data-testid={SORT_BUTTON}
        currentSortBy={currentlySortedBy}
        sortOptions={availableSortOptions}
        onSortChange={onChange}
        direction={sortDirection}
        showDirectionInMenu={showDirectionInMenu}
      />
    );
  },
);

ViewSortingMenuComponent.displayName = 'ViewSortingMenuComponent';
